// Stores a value in localStorage as JSON.
export function toLocalStorage(key, data) {
    window.localStorage.setItem(key, JSON.stringify(data));
}

// Reads a value from localStorage and safely parses JSON, falling back to raw string when needed.
export function fromLocalStorage(key) {
    const value = window.localStorage.getItem(key);

    if (value === null) {
        return null;
    }

    try {
        return JSON.parse(value);
    } catch (error) {
        return value;
    }
}
